<!-- Sidebar at background level -->
<div class="fixed left-0 top-0 h-screen z-10">
  <!-- Sidebar Container -->
  <div
    [style.width.px]="sidebarService.width()"
    class="h-full transition-all duration-300 ease-in-out flex flex-col bg-sidebar border-sidebar-border"
  >
    <!-- Header with Logo -->
    <div
      class="p-4 bg-sidebar border-b border-sidebar-border flex items-center justify-center"
    >
      @if (!isCollapsed()) {
        <img
          src="/logos/KenergySolutions_B.svg"
          alt="Kenergy Solutions"
          class="h-10"
        />
      } @else {
        <div
          class="w-8 h-8 bg-primary rounded-lg flex items-center justify-center"
        >
          <ng-icon
            name="lucideBook"
            class="w-4 h-4 text-primary-foreground"
          ></ng-icon>
        </div>
      }
    </div>

    <!-- Navigation -->
    <div class="flex-1 overflow-y-auto py-4 bg-sidebar">
      <nav class="px-2 space-y-6">
        <!-- Documentation Categories -->
        @for (category of groupedDocs() | keyvalue; track category.key) {
          @if (!isCollapsed()) {
            <div class="px-3 mb-2">
              <h3
                class="ks-eyebrow flex items-center"
              >
                <ng-icon name="lucideBook" class="w-3 h-3 mr-2"></ng-icon>
                {{ category.key }}
              </h3>
            </div>
          }

          <ul class="space-y-1">
            @for (doc of category.value; track doc.slug) {
              <li>
                <button
                  [routerLink]="'/docs/' + doc.slug"
                  [attr.aria-label]="doc.title" [attr.title]="doc.title"
                  routerLinkActive
                  #rla="routerLinkActive"
                  hlmBtn
                  variant="ghost"
                  class="w-full min-w-0 text-sm text-muted-foreground hover:text-foreground"
                  [class.justify-center]="isCollapsed()"
                  [class.justify-start]="!isCollapsed()"
                  [class.!font-bold]="rla.isActive"
                  [class.text-black]="rla.isActive"
                >
                  @if (!isCollapsed()) {
                    <span class="min-w-0 flex-1 truncate text-left">{{ doc.title }}</span>
                  } @else {
                    <ng-icon name="lucideBook" class="size-4" />
                  }
                </button>
              </li>
            }
          </ul>
        }
      </nav>
    </div>

    <!-- Footer with Return Button -->
    <div class="p-4 bg-sidebar border-t border-sidebar-border">
      <button
        hlmBtn
        variant="ghost"
        class="w-full min-w-0 text-sm text-muted-foreground hover:text-foreground"
        [class.justify-center]="isCollapsed()"
        [class.justify-start]="!isCollapsed()"
        aria-label="Zur App"
        (click)="goToApp()"
      >
        <ng-icon
          name="lucideArrowLeft"
          class="w-4 h-4"
          [class.mr-3]="!isCollapsed()"
        ></ng-icon>
        @if (!isCollapsed()) {
          <span>Zur App</span>
        }
      </button>
    </div>
  </div>
</div>
